import { useEffect, useState } from 'react';
import { onlineState, install } from '../lib/pwa';
import { outbox } from '../lib/offline';

// Pruh stavu PWA: offline upozornění, počet akcí ve frontě, tlačítko instalace.
const DISMISS_KEY = 'pwa-install-dismissed';
export default function PwaBar() {
  const [online, setOnline] = useState(onlineState.get());
  const [queued, setQueued] = useState(outbox.size());
  const [canInstall, setCanInstall] = useState(install.available());
  const [installDismissed, setInstallDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });
  const dismissInstall = () => {
    setInstallDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* bez úložiště se jen schová do reloadu */ }
  };
  const showInstall = canInstall && !installDismissed;

  useEffect(() => onlineState.subscribe(setOnline), []);
  useEffect(() => outbox.subscribe(() => setQueued(outbox.size())), []);
  useEffect(() => install.subscribe(() => setCanInstall(install.available())), []);

  if (online && queued === 0 && !showInstall) return null;

  return (
    <div className={`flex items-center gap-3 px-4 py-1.5 text-xs ${online ? 'bg-zinc-100 dark:bg-zinc-900 text-zinc-600 dark:text-zinc-300' : 'bg-amber-500 text-white'}`}>
      {!online && <span className="font-medium">● Offline — změny se uloží a odešlou po připojení.</span>}
      {queued > 0 && <span>{online ? 'Odesílám' : 'Ve frontě'}: {queued} {queued === 1 ? 'akce' : 'akcí'}</span>}
      {showInstall && (
        <span className="ml-auto flex items-center gap-1">
          <button onClick={() => install.prompt()} className="rounded border border-current px-2 py-0.5 hover:opacity-80">
            📲 Instalovat appku
          </button>
          <button onClick={dismissInstall} aria-label="Skrýt nabídku instalace" title="Skrýt" className="px-1.5 py-0.5 hover:opacity-70">✕</button>
        </span>
      )}
    </div>
  );
}
